import { ServiceCardsCartProps } from '@/types/serviceCards.types';
import styles from './serviceCardsCard.module.scss';
import Image from 'next/image';

const ServiceCardsCart = ({ card }: ServiceCardsCartProps) => {
  const { title, description, icon } = card;

  return (
    <div className={styles.cardContainer}>
      <div className={styles.cardWrapper}>
        <div className={styles.cardIcon}>
          <Image src={icon} alt={title} width={80} height={80} quality={85} />
        </div>
        <div className={styles.cardContent}>
          <h3
            className={styles.cardTitle}
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <p
            className={styles.cardDescription}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </div>
      </div>
    </div>
  );
};

export default ServiceCardsCart;
